import api from "@/constants/api";

// Accountant doc 2026-10-03, item 1.9 (Snap charge center): a COMPANY center
// sends either from its cash balance (channel "cash", what every center has
// always done) or from a separate gift budget the company funds (channel
// "gift"). The recipient is credited the same way; only the source and the
// accounting entry differ. Ordinary centers never see any of this and never
// send a channel, so their requests stay exactly as before.
//
// The flag and the budget come from the center profile (check_auth), which
// the app already loads; each transfer answer carries the budget left.
export default {
  data() {
    return {
      isCompanyCenter: false,
      giftBalance: 0,
      channel: "cash",
    };
  },
  created() {
    this.applyCenterProfile(this.$store && this.$store.state.user);
    this.loadCenterProfile();
  },
  watch: {
    // Every new transfer starts on cash: a gift is always a deliberate choice.
    dialog(open) {
      if (open) {
        this.channel = "cash";
      }
    },
  },
  methods: {
    applyCenterProfile(profile) {
      if (!profile) return;
      this.isCompanyCenter = !!profile.is_company;
      this.giftBalance = Number(profile.gift_balance || 0);
      if (!this.isCompanyCenter) {
        this.channel = "cash";
      }
    },
    loadCenterProfile() {
      return this.axios
        .get(api.ACTIONS.CHECK_TOKEN)
        .then(({ data }) => this.applyCenterProfile(data && data.data))
        .catch(() => {});
    },
    // Only a company center ever sends the parameter.
    channelPayload() {
      return this.isCompanyCenter ? { channel: this.channel } : {};
    },
    afterTransfer(result) {
      if (result && result.gift_balance !== undefined && result.gift_balance !== null) {
        this.giftBalance = Number(result.gift_balance);
      }
    },
  },
};
